import React, { useEffect, useState } from "react";

/**
 * Rotates a list of phrases with a typewriter cadence.
 * Each phrase types in, holds, then deletes itself before the next.
 */
export default function Typewriter({ phrases = [], speed = 70, hold = 1400, className = "" }) {
  const [i, setI] = useState(0); // phrase index
  const [t, setT] = useState(""); // current displayed text
  const [del, setDel] = useState(false);

  useEffect(() => {
    if (!phrases.length) return;
    const target = phrases[i % phrases.length];

    if (!del && t === target) {
      const id = setTimeout(() => setDel(true), hold);
      return () => clearTimeout(id);
    }
    if (del && t === "") {
      setDel(false);
      setI((p) => (p + 1) % phrases.length);
      return;
    }
    const id = setTimeout(
      () => setT((cur) => (del ? cur.slice(0, -1) : target.slice(0, cur.length + 1))),
      del ? Math.max(28, speed / 2) : speed,
    );
    return () => clearTimeout(id);
  }, [t, del, i, phrases, speed, hold]);

  return (
    <span className={className}>
      {t}
      <span className="inline-block w-[2px] h-[1em] bg-current align-middle ml-1 animate-pulse" />
    </span>
  );
}
